import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
const services = [{
  title: 'Корпоративні події',
  description: 'Гала-вечері, церемонії нагородження та масштабні святкування для лідерів ринку.',
  image: 'https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=2069&auto=format&fit=crop'
}, {
  title: 'Приватні вечірки',
  description: 'Ексклюзивні дні народження та закриті заходи з унікальною концепцією.',
  image: 'https://images.unsplash.com/photo-1566737236500-c8ac43014a67?q=80&w=2070&auto=format&fit=crop'
}, {
  title: 'Весілля',
  description: 'Режисура найважливішого дня з акцентом на естетику та індивідуальність пари.',
  image: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?q=80&w=2070&auto=format&fit=crop'
}, {
  title: 'Бренд-активації',
  description: 'Презентації продуктів та PR-події, що створюють потужний медіа-резонанс.',
  image: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?q=80&w=2070&auto=format&fit=crop'
}];
export function Services() {
  return <section id="services" className="py-24 bg-surface relative" data-id="element-141">
      <div className="container mx-auto px-6 md:px-12" data-id="element-142">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 md:mb-24" data-id="element-143">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-144">
            <h2 className="text-gold uppercase tracking-[0.2em] text-sm font-sans mb-4" data-id="element-145">
              Експертиза
            </h2>
            <h3 className="text-4xl md:text-6xl font-serif text-ivory" data-id="element-146">
              Наші Послуги
            </h3>
          </motion.div>

          <motion.p className="text-ivory/60 font-sans max-w-md mt-6 md:mt-0 text-sm md:text-base" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-147">
            Кожен формат вимагає свого підходу, але незмінним залишається наш
            рівень виконання — бездоганний.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-16" data-id="element-148">
          {services.map((service, index) => <motion.div key={index} className="group relative cursor-none" initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          delay: index * 0.1
        }} data-id="element-149">
              <div className="overflow-hidden relative aspect-[4/3] mb-6" data-id="element-150">
                <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-700 z-10" data-id="element-151"></div>
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-1000 ease-[cubic-bezier(0.25,1,0.5,1)]" data-id="element-152" />
              </div>
              <div className="flex justify-between items-start" data-id="element-153">
                <div data-id="element-154">
                  <h4 className="text-2xl md:text-3xl font-serif mb-3 group-hover:text-gold transition-colors duration-300" data-id="element-155">
                    {service.title}
                  </h4>
                  <p className="text-ivory/60 font-sans text-sm md:text-base max-w-sm" data-id="element-156">
                    {service.description}
                  </p>
                </div>
                <div className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center group-hover:bg-gold group-hover:border-gold group-hover:text-background transition-all duration-300" data-id="element-157">
                  <ArrowUpRight size={20} data-id="element-158" />
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}